import React from 'react';
import {Tooltip} from 'material-ui';
import DeleteIcon from 'material-ui-icons/Delete';
import DisableIcon from 'material-ui-icons/VisibilityOff';
import EnableIcon from 'material-ui-icons/Visibility';

const actions = ({
    classes, 
    deletable, 
    visible,
    invisible,
    deleteSection,
    disableSection,
    enableSection,
    hideActions
}) => (
    !hideActions &&
    <div className={classes.pbSortSectionActions}>
        {deletable &&
        <span className="floatRight">
            <Tooltip title="Delete Section">
                <DeleteIcon className="smallIconButtonPages deleteColor" onClick={deleteSection} />
            </Tooltip>
        </span>}
        <span>
            {visible &&
                <span className="floatRight">
                    <Tooltip title="Disable Section">
                        <DisableIcon className="smallIconButtonPages disableColor" onClick={disableSection}/>
                    </Tooltip>
                </span>
            }
            {invisible &&
                <span className="floatRight">
                    <Tooltip title="Enable Section">
                        <EnableIcon className="smallIconButtonPages enableColor" onClick={enableSection}/>
                    </Tooltip>
                </span>
            }
        </span>
    </div>
);

export default actions;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/sections/tab_dnd/SectionActions.jsx